import React, { Component } from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import MuiAlert from "@material-ui/lab/Alert";
import SwipeableViews from "react-swipeable-views";
import { connect } from "react-redux";
import {
  Collapse,
  CardHeader,
  CardContent,
  Button,
  List,
  Drawer,
  Fab,
  Tabs,
  CircularProgress,
  Tab,
  Badge,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
  Paper,
  Tooltip,
} from "@material-ui/core";
import { withRouter } from "react-router";
import { Trans, withTranslation } from "react-i18next";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import FolderIcon from "@material-ui/icons/Folder";
import { discussionClient } from "../../../AxiosClient";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CloseIcon from "@material-ui/icons/Close";
import DiscussionEntries from "../../discussions/DiscussionEntries";
import CreateDiscussion from "../../discussions/CreateDiscussion";
import TaxonomyTree from "../TaxonomyTree";
import ItemDiscussions from "../../list-item/ItemDiscussions";
import classNames from "classnames";
import Snackbar from "@material-ui/core/Snackbar";
import { Route } from "react-router-dom";
import { mdiFileDocumentEditOutline } from "@mdi/js";
import Icon from "@mdi/react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FunctionsIcon from '@material-ui/icons/Functions';

const drawerWidth = "30%";
const taxonomySVG =
  "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z";
const topicSVG =
  "M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z";

const styles = (theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    height: "100%",
    overflow: "visisble",
  },
  drawerOpen: {
    // width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    position: "relative",
    textOverflow: "ellipsis",
    height: "100%",
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    textOverflow: "ellipsis",
    // width: theme.spacing(6) + 1,
    // "& #sidebarContent": {
    // },
    width: 0,
    position: "relative",
    height: "100%",
  },
  settingsTable: {
    margin: 10,
    flex: 1,
  },
  header: {
    marginBottom: 15,
    display: "flex",
  },
  container: {
    height: "100%",
    width: "100%",
  },
  flexContainer: {
    display: "flex",
  },
  alert: {
    width: "50%",
    margin: 5,
  },
  accordionRoot: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      // borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  accordionSummaryRoot: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  tooltip: { zIndex: 10003 },
});
const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -8,
    padding: '0 6px',
  },
}))(Badge);
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
class TaxonomyDiscussions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      revisionOpen: false,
      discussionOpen: true,
      discussions: [],
      discussion: {},
      topicColourTheme: `${this.props.theme.palette.primary.dark}`,
      taxonomyColourTheme: `${this.props.theme.palette.primary.light}`,
      createEntryOpen: false,
      openCreateEntry: false,
      selected: 0,
      selectedNode: {},
      taxonomyOpen: true,
      gettingDiscussions: false,
      selectedDiscussions: 0,
      entryPage: 0,
      openSnackbar: false,
      snackbarMessage: "",
      unreadExpert: 0,
      unreadPublic: 0,
      badges: [],
      unreadTaxonomy: 0,
      unreadTopic: 0,
      nodesToExpand: null,
    };
  }
  componentDidMount() {
    this.getDiscussions()
  }
  getDiscussions = (node, index) => {
    let taxonomySummaryUrl = `/discussion/taxonomysummary/`
    discussionClient.get(taxonomySummaryUrl).then((res) => {
      let unreadTaxonomy = res.data.filter(s => s.type === "TAXONOMY_NODE").map(s=> s.unread).reduce((a, b) => a + b, 0)
      let unreadTopic = res.data.filter(s => s.type === "TOPIC").map(s=> s.unread).reduce((a, b) => a + b, 0)
      let nodesToExpand = res.data.filter(s => s.unread > 0).map(s=> s.id).length > 0 ?
        res.data.filter(s => s.unread > 0).map(s=> s.id) : null
      
      if (!areObjectsEqual(res.data, this.state.badges)) {
        this.setState({badges: res.data, unreadTaxonomy: unreadTaxonomy, unreadTopic: unreadTopic, nodesToExpand: nodesToExpand })
      }

      if (node && node.id) {
        this.setState({
          selected: 0,
          discussions: [],
          selectedNode: node,
          gettingDiscussions: !node.treeOnly,
          unreadExpert: 0,
          unreadPublic: 0,
        });
        this.props.history.replace({
          pathname: `/full/taxonomydiscussions/${node.type}/${
            node.id
          }/discussion/`,
          state: { nodeId: node.id },
        });

        let type = node.type === "taxonomy" ? "TAXONOMY_NODE" : "TOPIC";
        let summaryUrl = `/discussion/summary?type=${type}&itemId=${node.id}`
        discussionClient.get(summaryUrl).then((res) => {
          this.props.updateUnread && this.props.updateUnread(res.data ? res.data.unreadExpert + res.data.unreadPublic : 0)
          this.setState({unreadPublic: res.data.unreadPublic, unreadExpert: res.data.unreadExpert})

          let index2use = (index === null || index === undefined)
            ? (node.treeOnly || !node.isUserExpert) 
              ? 0
              : res.data.unreadExpert > 0 && res.data.unreadPublic === 0
                ? 1
                :  res.data.unreadExpert === 0 && res.data.unreadPublic > 0
                  ? 0
                  : this.state.selectedDiscussions
            : index
          
          this.state.selectedDiscussions !== index2use && this.setState({selectedDiscussions : index2use})
      
          let url = `/discussion/?type=${type}&itemId=${node.id}`;
          if (index2use != null && index2use != undefined) {
            url = url + `&expert=${index2use}`;
          }
          !node.treeOnly &&
            discussionClient.get(url).then((res) => {
              this.setState({
                discussions: res.data.content,
                gettingDiscussions: false,
              });
              if (this.props.discussionId) {
                res.data.content.map((discussion) => {
                  if (discussion.discussionId === this.props.discussionId) {
                    this.onItemClick(discussion);
                  }
                });
              }
            });
        });
      }
    })
  };
  onItemClick = (discussion) => {
    this.setState({ discussion: discussion, selected: 1 });
    this.props.history.replace({
      pathname: `/full/taxonomydiscussions/${this.state.selectedNode.type}/${
        this.state.selectedNode.id
      }/discussion/${discussion.discussionId}`,
      state: { discussionId: discussion.discussionId },
    });
  };
  onRevisionClick = (selectedRevision) => {
    this.setState({ selectedRevision });
  };
  removeDiscussion = (discussionId) => {
    let discussions = this.state.discussions.filter(
      (discussion) => discussion.discussionId !== discussionId
    );
    this.setState({ discussions });
  };
  openSnackbar = (message) => {
    this.setState({ openSnackbar: true, snackbarMessage: message });
  };
  routerDiscussion = (location) => {
    if (this.state.discussion.discussionId === undefined) {
      let url = `/discussion/${location.match.params.discussionId}`;
      discussionClient.get(url).then((res) => {
        this.setState({ discussion: res.data, selected: 1 });
      });
    }
    return <></>;
  };
  updateDiscussion = (discussion) => {
    this.setState({ discussion });
  };
  render() {
    let isExpert =
      this.props.user.userPermits.roles.beExpert ||
      this.props.user.userPermits.roles.administrator ||
      this.props.user.userPermits.roles.administrator.systemManager;
    let currentPath = this.props.match.url;
    const { classes, t } = this.props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          overflowWrap: "anywhere",
          height: "calc(100% - 64px)",
          width: "100%",
        }}
      >
        <Route
          path={`${currentPath}/:type/:nodeId/discussion/:discussionId`}
          exact
          component={this.routerDiscussion}
        />
        <Drawer
          className={classNames(classes.drawer, {
            [classes.drawerOpen]: this.state.taxonomyOpen,
            [classes.drawerClose]: !this.state.taxonomyOpen,
          })}
          classes={{
            paper: classNames({
              [classes.drawerOpen]: this.state.taxonomyOpen,
              [classes.drawerClose]: !this.state.taxonomyOpen,
            }),
          }}
          // className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={this.state.taxonomyOpen}
        >
          <CardHeader
            title={<div>Taxonomy select</div>}
            action={
              <IconButton
                onClick={() =>
                  this.setState({ taxonomyOpen: !this.state.taxonomyOpen })
                }
              >
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <Accordion classes={{ root: classes.accordionRoot }}>
              <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    classes={{ root: classes.accordionSummaryRoot }}
              >
                <Typography className={classes.heading}>
                  {this.props.t("required_reading_unread") + " " + t("global_discussion_plural") + " " + t("summary") + " ( "}  
                  {this.state.unreadTopic + this.state.unreadTaxonomy} { " )"}
                </Typography>
              </AccordionSummary>            
              <AccordionDetails>
                <TableContainer
                  component={Paper}
                  className={classes.settingsTable}
                >
                  <Table
                    size="small"
                    style={{ overflowWrap: "anywhere" }}
                    tabindex={0}
                    aria-label={this.props.t("required_reading_unread") + " " + t("global_discussion_plural") + " " + t("summary")}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell align="right" />
                        <TableCell align="center">
                          <Tooltip
                            classes={{ popper: classes.tooltip }}
                            title={
                              <Typography>
                                {this.props.t("required_reading_unread") + " " + t("global_taxonomy") + " " + t("global_discussion_plural")}
                              </Typography>
                            }
                          >
                            <svg height="24px" width="24px">
                              <path
                                fill={this.state.taxonomyColourTheme}
                                d={taxonomySVG}
                              />
                            </svg>
                          </Tooltip>
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip
                            classes={{ popper: classes.tooltip }}
                            title={
                              <Typography>
                                {this.props.t("required_reading_unread") + " " + t("global_topic") + " " + t("global_discussion_plural")}
                              </Typography>
                            }
                          >
                            <svg height="24px" width="24px">
                              <path
                                fill={this.state.topicColourTheme}
                                d={topicSVG}
                              />
                            </svg>
                          </Tooltip>
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip
                            classes={{ popper: classes.tooltip }}
                            title={
                              <Typography>
                                {t("report_totals")}
                              </Typography>
                            }
                          >
                            <FunctionsIcon/>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>{this.props.extendedString}
                      <TableRow>
                        <TableCell align="right">
                          {this.props.t("required_reading_unread")}
                        </TableCell>
                        <TableCell align="center">
                          {this.state.unreadTaxonomy}
                        </TableCell>
                        <TableCell align="center">
                          {this.state.unreadTopic}
                        </TableCell>
                        <TableCell align="center">
                          {this.state.unreadTopic + this.state.unreadTaxonomy}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>

            <TaxonomyTree
              // includeRoledUsers
              noElevate
              onNodeSelected={(node) => this.getDiscussions(node)}
              allowedSelections={["taxonomy", "topic"]}
              filter={this.props.filter ? this.props.filter : []}
              treeType="discussions"
              badges={this.state.badges}
              badgeValueField={"unread"}
              badgeMessageKey={"required_reading_unread"}
              startWithExpanded={this.state.nodesToExpand}
            />
          </CardContent>
        </Drawer>
        {!this.state.taxonomyOpen && (
          <div style={{ paddingLeft: 24, paddingTop: 8 }}>
            <IconButton
              aria-label="delete"
              onClick={() => {
                this.setState({ taxonomyOpen: true });
              }}
            >
              <AccountTreeIcon />
            </IconButton>
          </div>
        )}
        <div style={{ width: "100%", overflow: "auto" }}>
          {this.state.openCreateDiscussion && (
            <CreateDiscussion
              expert={this.state.selectedDiscussions}
              discussionOnId={this.state.selectedNode.id}
              top={10}
              type={this.state.selectedNode.type}
              open={this.state.openCreateDiscussion}
              addedDiscussion={this.state.addedDiscussion}
              onDiscussionAdded={(discussion) =>
                this.setState({
                  discussions: [discussion, ...this.state.discussions],
                })
              }
              changeOpenCreateDiscussion={() =>
                this.setState({ openCreateDiscussion: false })
              }
            />
          )}
          <SwipeableViews
            style={{ height: "100%" }}
            index={this.state.selected}
            containerStyle={{ height: "100%" }}
            slideStyle={{ width: "100%", overflowX: "hidden", height: "100%" }}
          >
            <div style={{ height: "100%" }}>
              <CardHeader
                title={
                  this.state.selectedNode.id
                    ? `${this.props.t("discussions_for")[0].toUpperCase() + this.props.t("discussions_for").substr(1)} ${this.state.selectedNode.name}`
                    : this.props.t("global_discussion_plural")
                }
              />
              <CardContent>
                {this.state.selectedNode.id ? (
                  (isExpert && !this.state.selectedNode.treeOnly) && (
                    <Tabs
                      value={this.state.selectedDiscussions}
                      onChange={(event, index) => {
                        this.setState({ selectedDiscussions: index }, () =>
                        this.getDiscussions(this.state.selectedNode, index)
                        )
                      }}
                      aria-label="simple tabs example"
                    >
                      {/* <Tab label={this.props.t("global_public")} /> */}
                        <Tab label={
                          <StyledBadge
                            color="secondary"
                            badgeContent={this.state.unreadPublic}
                          >
                            <Typography>{this.props.t("global_public") + "  "}</Typography>
                          </StyledBadge>}/>
                      {this.state.selectedNode.isUserExpert &&
                        // <Tab label={this.props.t("global_expert")} />
                        <Tab label={
                          <StyledBadge
                            color="secondary"
                            badgeContent={this.state.unreadExpert}
                          >
                            <Typography>{this.props.t("global_expert") + "  "}</Typography>
                          </StyledBadge>}/>
                      }
                    </Tabs>
                  )
                ) : (
                  <div>
                    {`${this.props.t("please_select_taxonomy_node")} `}
                    <FolderIcon
                      style={{ color: this.props.theme.palette.primary.light }}
                    />
                    {` ${this.props.t("or_a_topic_node")} `}
                    <svg height="24px" width="24px">
                      <path fill={this.state.topicColourTheme} d={topicSVG} />
                    </svg>
                    {` ${this.props.t("from_left_drawer")}. `}
                  </div>
                )}
                {this.state.discussions.length < 1 &&
                this.state.selectedNode.id ? (
                  <>
                    {this.state.gettingDiscussions ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          height: "100%",
                        }}
                      >
                        <div style={{ display: "flex", width: "100%" }} />
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div style={{ display: "flex", height: "100%" }} />
                          <CircularProgress
                            size={100}
                            className="add-choice-dialog-spinner"
                          />
                          <div style={{ display: "flex", height: "100%" }} />
                        </div>
                        <div style={{ display: "flex", width: "100%" }} />
                      </div>
                    ) : (
                      <>
                      {!this.state.selectedNode.treeOnly ? (
                        <div style={{ padding: 16 }}>
                          {`${this.props.t("global_no")} ${this.state.selectedDiscussions === 0
                            ? this.props.t("global_public")
                            : this.props.t("global_expert")} ${this.props.t("discussions_for")} ${this.state.selectedNode.name}`}
                        </div>
                      ) : (
                        <>{`${this.props.t("no_discussion_permissions_for")} ${this.state.selectedNode.name} ${this.props.t("please_select_a_child")}`}</>
                      )}
                      </>
                    )}
                  </>
                ) : (
                  <div>
                    <List id="discussions-list">
                      {this.state.discussions.map((item, idx) => {
                        return (
                          // <Badge
                          // 	className={classes.badge}
                          // 	badgeContent={this.state.unreadDiscussions ? 1 : 0}
                          // 	color="secondary"
                          // >
                          <ItemDiscussions
                            removeDiscussion={this.removeDiscussion}
                            canModerate
                            noFullscreen
                            openSnackbar={this.openSnackbar}
                            key={item.discussionId}
                            discussionPortlet={false}
                            onItemClick={this.onItemClick}
                            portlet={false}
                            data={item}
                            refreshDiscussions={() =>
                              this.getDiscussions(
                                this.state.selectedNode
                              )
                            }
                          />
                          // </Badge>
                        );
                      })}
                    </List>
                  </div>
                )}
              </CardContent>
            </div>
            <div style={{ height: "100%" }}>
              {this.state.selected === 1 && (
                <DiscussionEntries
                  openCreateContent={() =>
                    this.props.history.replace({
                      pathname: `/full/discussion/${
                        this.state.discussion.discussionId
                      }`,
                      state: { createContent: true },
                    })
                  }
                  updateDiscussion={this.updateDiscussion}
                  discussionId={this.state.discussion.discussionId}
                  action={
                    <div>
                      <IconButton
                        onClick={() =>
                          this.props.history.replace({
                            pathname: `/full/discussion/${
                              this.state.discussion.discussionId
                            }`,
                          })
                        }
                      >
                        <Icon path={mdiFileDocumentEditOutline} size={1} />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          this.setState({ selected: 0 });
                          this.getDiscussions(
                            this.state.selectedNode
                          );
                          if (this.state.selectedNode.id) {
                            this.props.history.replace({
                              pathname: `/full/taxonomydiscussions/${
                                this.state.selectedNode.id
                              }/discussion/`,
                              state: { nodeId: this.state.selectedNode.id },
                            });
                          } else {
                            this.props.history.replace({
                              pathname: `/full/taxonomydiscussions/`,
                            });
                          }
                        }}
                      >
                        <ArrowBackIcon />{" "}
                      </IconButton>{" "}
                    </div>
                  }
                  showBackButton
                  discussion={this.state.discussion}
                  updateSummary={() => {
                    this.getDiscussions(this.state.selectedNode.id)
                  }}
                />
              )}
            </div>
          </SwipeableViews>
          {(this.state.selectedNode.id && !this.state.selectedNode.treeOnly) &&
            this.state.selected === 0 && (
              <Fab
                onClick={() => this.setState({ openCreateDiscussion: true })}
                color="primary"
                aria-label={this.props.t("create_discussion_header")}
                style={{
                  position: "absolute",
                  bottom: 10,
                  right: 10,
                }}
              >
                <AddIcon />
              </Fab>
            )}
        </div>
        <Snackbar
          open={this.state.openSnackbar}
          autoHideDuration={6000}
          onClose={() =>
            this.setState({ openSnackbar: false, snackbarMessage: "" })
          }
        >
          <Alert severity="success">{this.state.snackbarMessage}</Alert>
        </Snackbar>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.user.currentUser,
});
export default connect(
  mapStateToProps,
  null
)(withTranslation()(withRouter(withTheme(withStyles(styles)(TaxonomyDiscussions)))));
